// this is only used for tv

import videojs from 'video.js';
import {Matomo} from "./helpers/Matomo";

// require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector/src/plugin');

// videojs.Vhs.GOAL_BUFFER_LENGTH = 20;
// videojs.Vhs.MAX_GOAL_BUFFER_LENGTH = 40;

let player = videojs('hls-player', {
    liveui: true,
    controlBar: {
        'liveDisplay': true,
        'pictureInPictureToggle': true,
        'seekToLive': false
    },
    // This option configures the Spatial Navigation within the Video.js player,
    // enhancing accessibility and user experience on devices like smart TVs,
    // where navigation through remote control is common.
    spatialNavigation: {
        enabled: true,
        horizontalSeek: true
    }
});

player.hlsQualitySelector({
  displayCurrentQuality: true,
});

Matomo.setPlayer(player);
player.on('play', () => Matomo.sendMatomo('play'));
player.on('ended', () => Matomo.sendMatomo('ended'));
player.on('seeked', () => Matomo.sendMatomo('seeked'));
player.on('error', () => Matomo.sendErrorMatomo('error'));

player.ready(() => {
    const promise = player.play();

    if (promise !== undefined) {
        promise.then(function () {
            // console.log('Autoplay started!');
        }).catch(function (error) {
            // console.warn('Autoplay was prevented');
        });
    }
});
